{
  "$schema": "../../schemas/shared-rules.schema.json",
  "namespace": "settlement",
  "templates": {
    "defaultSettlementMethodCascade": {
      "watch": "{{prefix}}/properties/defaultSettlementTypeId",
      "set": {
        "{{prefix}}/properties/settlementMethods": {
          "operator": "appendUnique",
          "target": "{{prefix}}/properties/settlementMethods"
        }
      }
    },
    "settlementWindowStart_greaterThanZero": {
      "target": "{{prefix}}/properties/windowStart",
      "rule": "greaterThan",
      "condition": {
        "field": "{{prefix}}/properties/windowStart",
        "notEmpty": true
      },
      "comparedTo": 0,
      "message": "Must be greater than 0"
    },
    "settlementWindowEnd_greaterThanZero": {
      "target": "{{prefix}}/properties/windowEnd",
      "rule": "greaterThan",
      "condition": {
        "field": "{{prefix}}/properties/windowEnd",
        "notEmpty": true
      },
      "comparedTo": 0,
      "message": "Must be greater than 0"
    },
    "settlementWindowEnd_lessThanStart": {
      "target": "{{prefix}}/properties/windowEnd",
      "rule": "lessThan",
      "condition": {
        "allOf": [
          {
            "field": "{{prefix}}/properties/windowEnd",
            "notEmpty": true
          },
          {
            "field": "{{prefix}}/properties/windowStart",
            "notEmpty": true
          }
        ]
      },
      "comparedTo": "{{prefix}}/properties/windowStart",
      "message": "Election window end must be less than window start"
    },
    "settlementWindowStart_requiredWhenEndFilled": {
      "target": "{{prefix}}/properties/windowStart",
      "rule": "required",
      "condition": {
        "field": "{{prefix}}/properties/windowEnd",
        "notEmpty": true
      },
      "message": "Required field"
    },
    "settlementWindowEnd_requiredWhenStartFilled": {
      "target": "{{prefix}}/properties/windowEnd",
      "rule": "required",
      "condition": {
        "field": "{{prefix}}/properties/windowStart",
        "notEmpty": true
      },
      "message": "Required field"
    },
    "settlementMethods_minOne": {
      "target": "{{prefix}}/properties/settlementMethods",
      "rule": "arrayMinItems",
      "condition": {
        "anyOf": [
          {
            "field": "{{prefix}}/properties/windowStart",
            "notEmpty": true
          },
          {
            "field": "{{prefix}}/properties/windowEnd",
            "notEmpty": true
          },
          {
            "field": "{{prefix}}/properties/defaultSettlementTypeId",
            "notEmpty": true
          }
        ]
      },
      "minValue": 1,
      "message": "Required field"
    },
    "settlementDefaultTypeId_requiredWhenMethodsSelected": {
      "target": "{{prefix}}/properties/defaultSettlementTypeId",
      "rule": "required",
      "condition": {
        "anyOf": [
          {
            "field": "{{prefix}}/properties/windowStart",
            "notEmpty": true
          },
          {
            "field": "{{prefix}}/properties/windowEnd",
            "notEmpty": true
          },
          {
            "field": "{{prefix}}/properties/settlementMethods",
            "notEmpty": true
          }
        ]
      },
      "message": "Required field"
    }
  }
}
